export const optionsSmoking = [
  "Não fumo",
  "Ocasionalmente",
  "Socialmente",
  "Frequentemente",
];
